import React, {useEffect, useState} from 'react'
import styles from './styles.module.scss'

const Cookie = () => {
	const show = !document.cookie.includes('show-cookie=no')

	const acceptCookie = () => {
		document.getElementById('cookie-popup').style.display = 'none'
		let date = new Date(Date.now() + 30 * 86400e3);
		date = date.toUTCString();
		document.cookie = `show-cookie=no; path=/; expires=${date}`;
	}

	return (
		show ? ( <div className={styles.wrapper} id='cookie-popup'>
			<div className={styles.content}>
				<p className={styles.title}>Мы используем куки!</p>
				<p className={styles.text}>
					Наш сайт использует cookies для персонализации пользовательских сервисов. Отключить сохранение cookies можно в настройках браузера. <a href='/cookie-policy/' target='_blank'>Подробнее</a>
				</p>
			</div>
			<div className={styles.accept} onClick={acceptCookie}>Ок</div>
		</div>) : ''
	)
}

export default Cookie
